import Vue from 'vue'
import Router from 'vue-router'
import global from '@/core/global/global'
var param = global.global.getParam();


Vue.use(Router)

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }


import main_routers from "./main_routers"//首页

var projects = [
  main_routers,//首页
]

var routes = (branches) => {
  var merge = [];
  branches.map(function(item) {
    merge.push.apply(merge, item);
  })
  return merge;
}
var router = new Router({
  routes: routes(projects)
})
router.beforeEach((to, from, next) => {
  if(location.href.indexOf("listType")!=-1){
    // to.path="/"
  }


  if (to.path == "/") {
    if (param.listType) {
      let aritcleId=param.id.split("#")[0];
      next({path:`/${param.listType}`,query:{id:aritcleId}});
    } else {
      next({path:"/index"});
    }
  } else {
    next();
  }
  next();

})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js